import React from 'react';

/**
 * Ambient Background - Subtle animated gradient orbs that create depth and atmosphere
 * Creates a fluid, living feel throughout the website
 */
const AmbientBackground = ({ 
  variant = 'default', // 'default', 'green', 'teal', 'warm', 'hero'
  className = ''
}) => {
  const variants = {
    // Hero section - more prominent
    hero: (
      <>
        {/* Large green orb - top left */}
        <div 
          className="absolute w-[800px] h-[800px] rounded-full animate-ambient-drift-1"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.15) 0%, rgba(89, 216, 98, 0.05) 40%, transparent 70%)',
            filter: 'blur(80px)',
            top: '-20%',
            left: '-15%',
          }}
        />
        {/* Teal accent - bottom right */}
        <div 
          className="absolute w-[600px] h-[600px] rounded-full animate-ambient-drift-2"
          style={{
            background: 'radial-gradient(circle, rgba(0, 64, 72, 0.25) 0%, rgba(0, 64, 72, 0.1) 40%, transparent 70%)',
            filter: 'blur(100px)',
            bottom: '-10%',
            right: '-10%',
          }}
        />
        {/* Small accent orb */}
        <div 
          className="absolute w-[400px] h-[400px] rounded-full animate-ambient-drift-3"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.1) 0%, transparent 60%)',
            filter: 'blur(60px)',
            top: '60%',
            left: '50%',
          }}
        />
      </>
    ),
    // Default - balanced green and teal
    default: (
      <>
        <div 
          className="absolute w-[600px] h-[600px] rounded-full animate-ambient-drift-1"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.12) 0%, transparent 70%)',
            filter: 'blur(100px)',
            top: '0%',
            left: '-10%',
          }}
        />
        <div 
          className="absolute w-[500px] h-[500px] rounded-full animate-ambient-drift-2"
          style={{
            background: 'radial-gradient(circle, rgba(0, 64, 72, 0.2) 0%, transparent 70%)',
            filter: 'blur(100px)',
            bottom: '0%',
            right: '-5%',
          }}
        />
      </>
    ),
    // Green focused
    green: (
      <>
        <div 
          className="absolute w-[700px] h-[700px] rounded-full animate-ambient-drift-1"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.1) 0%, transparent 70%)',
            filter: 'blur(100px)',
            top: '10%',
            left: '0%',
          }}
        />
        <div 
          className="absolute w-[500px] h-[500px] rounded-full animate-ambient-drift-3"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.08) 0%, transparent 70%)',
            filter: 'blur(80px)',
            bottom: '10%',
            right: '10%',
          }}
        />
      </>
    ),
    // Teal focused
    teal: (
      <>
        <div 
          className="absolute w-[600px] h-[600px] rounded-full animate-ambient-drift-2"
          style={{
            background: 'radial-gradient(circle, rgba(0, 64, 72, 0.2) 0%, transparent 70%)',
            filter: 'blur(100px)',
            top: '-10%',
            right: '0%',
          }}
        />
        <div 
          className="absolute w-[400px] h-[400px] rounded-full animate-ambient-drift-1"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.08) 0%, transparent 70%)',
            filter: 'blur(80px)',
            bottom: '20%',
            left: '10%',
          }}
        />
      </>
    ),
    // Warm accent
    warm: (
      <>
        <div 
          className="absolute w-[500px] h-[500px] rounded-full animate-ambient-drift-1"
          style={{
            background: 'radial-gradient(circle, rgba(196, 185, 166, 0.1) 0%, transparent 70%)',
            filter: 'blur(100px)',
            top: '20%',
            left: '20%',
          }}
        />
        <div 
          className="absolute w-[400px] h-[400px] rounded-full animate-ambient-drift-3"
          style={{
            background: 'radial-gradient(circle, rgba(89, 216, 98, 0.06) 0%, transparent 70%)',
            filter: 'blur(80px)',
            bottom: '10%',
            right: '20%',
          }}
        />
      </>
    ),
  };

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {variants[variant]}
    </div>
  );
};

export default AmbientBackground;
